import { createAsyncThunk } from "@reduxjs/toolkit";
import viewTrackingService from "../../../api/services/viewTracking";
import festivalsService from "../../../api/services/festivals";

const normalizeOwnerArg = (arg) => {
  if (arg && typeof arg === "object") {
    return { bandId: arg.bandId, festivalId: arg.festivalId };
  }
  return { bandId: arg, festivalId: null };
};

export const trackBandView = createAsyncThunk(
  "viewTracking/track-band-view",
  async (bandId) => {
    return await viewTrackingService.trackBandView(bandId);
  },
);

export const getBandViewStats = createAsyncThunk(
  "viewTracking/get-band-view-stats",
  async (arg) => {
    const { bandId, festivalId } = normalizeOwnerArg(arg);
    if (festivalId) {
      return await festivalsService.getFestivalViewStats(festivalId);
    }
    return await viewTrackingService.getBandViewStats(bandId);
  },
);

export const getMostViewedBands = createAsyncThunk(
  "viewTracking/get-most-viewed-bands",
  async ({ limit, days } = {}) => {
    return await viewTrackingService.getMostViewedBands({ limit, days });
  },
);
